import { Loader } from "@common/handleErrorAndLoading/Loader";
import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useResetPassword } from "./hooks/useResetPassword";

export const UserPassword = () => {
    const { resetPassword, resetPasswordState, isLinkSent } = useResetPassword();
    const { t } = useTranslation(["profile", "common"]);

    return (
        <Fragment>
            <Grid alignItems="center" className="mydetail__fields" container spacing={1} item>
                <Grid item sm={4} xs={12}>
                    <Grid container direction="column">
                        <Typography color="textSecondary" id="detailPassword" variant="body2">
                            {t("profile:password")}
                        </Typography>
                        <Typography aria-labelledby="detailPassword" variant="body1">
                            **********
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item sm={8} xs={12}>
                    {resetPasswordState.isLoading && <Loader size={40} />}
                    {!resetPasswordState.isLoading && (
                        <Button
                            color="secondary"
                            size="large"
                            type="button"
                            variant="contained"
                            onClick={resetPassword}
                        >
                            {t("profile:resetPassword")}
                        </Button>
                    )}
                </Grid>
            </Grid>
            {resetPasswordState.error && (
                <Grid className="mydetail-password__info" item xs={12}>
                    <Typography color="error" variant="body1">
                        {t("common:genericError")}
                    </Typography>
                </Grid>
            )}
            {isLinkSent && (
                <Grid className="mydetail-password__info" item xs={12}>
                    <Typography variant="body1">{t("profile:linkSent")}</Typography>
                    <Typography variant="body1">{t("profile:linkSentHelper")}</Typography>
                </Grid>
            )}
        </Fragment>
    );
};
